import React from 'react'
import { Table, Button, Tooltip, ActionIcon, Menu } from '@mantine/core'
import { IconInfoCircle, IconPencil, IconDotsVertical } from '@tabler/icons-react'

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={130} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const OrderInvoiceNumberTable = ({ label, data, actionMethod }) => {

  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {

    const mappingMenuAction = (invoiceCode) => {
      if (invoiceCode === null || invoiceCode === '-') {
        return (
          <Tooltip label='No Action Available' withArrow>
            <ActionIcon ml={10} mt={6} variant='transparent' size='xs'>
              <IconInfoCircle stroke={1.5}/>
            </ActionIcon>
          </Tooltip>
        )
      } else {
        return (
          <ActionMenu handleAction={(type) => actionMethod(val, type)} />
        )
      }
    }
    return (
      <Table.Tr key={index}>
        <Table.Td>{val.name}</Table.Td>
        <Table.Td>{val.invoice_code ? val.invoice_code : <Button size='compact-xs' fz={10} variant="filled" onClick={() => actionMethod(val, 'generate')}>Generate</Button>}</Table.Td>
        <Table.Td>{val.name}</Table.Td>
        <Table.Td>{val.tracking_code || '-'}</Table.Td>
        <Table.Td>{val.courier_name || '-'}</Table.Td>
        <Table.Td>{mappingMenuAction(val.invoice_code)}</Table.Td>
      </Table.Tr>
    )
  })


  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default OrderInvoiceNumberTable